import { render, staticRenderFns } from "./kyc_step.vue?vue&type=template&id=f45e1df8&scoped=true"
import script from "./kyc_step.vue?vue&type=script&lang=js"
export * from "./kyc_step.vue?vue&type=script&lang=js"
import style0 from "./kyc_step.vue?vue&type=style&index=0&id=f45e1df8&prod&scoped=true&lang=css"
import style1 from "./kyc_step.vue?vue&type=style&index=1&id=f45e1df8&prod&lang=css"
import style2 from "./kyc_step.vue?vue&type=style&index=2&id=f45e1df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45e1df8",
  null
  
)

export default component.exports